import createSagaMiddleware, { SagaMiddlewareOptions } from 'redux-saga';
import { configureStore as configureStoreOriginal } from '@reduxjs/toolkit';

import rootReducerFactory from './reducers';
import rootSaga from './saga';

function configureStore({
    sagaOptions = {},
    devToolsName,
}: {
    sagaOptions: SagaMiddlewareOptions;
    devToolsName: string;
}) {
    const sagaMiddleware = createSagaMiddleware(sagaOptions);

    const store = configureStoreOriginal({
        reducer: rootReducerFactory(),

        middleware: getDefaultMiddleware =>
            getDefaultMiddleware({ serializableCheck: false }).concat(sagaMiddleware),

        devTools: process.env.NODE_ENV === 'development' && {
            shouldHotReload: false,
            name: devToolsName,
        },
    });

    // Extensions
    (store as any).runSaga = sagaMiddleware.run;
    (store as any).injectedReducers = {}; // Reducer registry
    (store as any).injectedSagas = {}; // Saga registry
    (store as any).createReducer = rootReducerFactory;

    sagaMiddleware.run(rootSaga);

    return store;
}

export type AppStore = ReturnType<typeof configureStore>;

export default configureStore;
